/**
 * This is a component with a scroll spy, allowing itself to change behavior
 * (fixed position) within a certain scroll position.
 *
 * For example: Imagine a timer that will be rendered on top as a regular block
 * element as default, but when the user scrolls at least 52px down the page the
 * timer will change to a fixed position, gluing itself right underneath the top
 * header. When scrolling back up it will go back to the 52px offset allowing
 * the ordering steps to render between header and the countdown.
 */
import React, {useState, useEffect} from 'react'
import PropTypes from 'prop-types'

function Affix({
  children,
  offset = 0,
  className,
  tagName = 'div',
  ...rest
}) {
  const [affix, setAffix] = useState(false)

  const handleScroll = () => {
    const scrollTop = document.documentElement.scrollTop || document.body.scrollTop

    setAffix(currentState => {
      if (!currentState && scrollTop >= offset) return true
      if (currentState && scrollTop <= offset) return false
      return currentState
    })
  }

  useEffect(() => {
    window.addEventListener('scroll', handleScroll)
    return () => window.removeEventListener('scroll', handleScroll)
  }, []) // eslint-disable-line react-hooks/exhaustive-deps

  const TagName = tagName
  return (
    <TagName {...rest} className={[className, affix ? 'affix' : ''].join(' ').trim()}>
      {children}
    </TagName>
  )
}

Affix.propTypes = {
  children: PropTypes.node,
  offset: PropTypes.number,
  className: PropTypes.string,
  tagName: PropTypes.string,
}

export default Affix
